import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmojiPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M13.267 2.08a10 10 0 108.653 8.653" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 10V9" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 5h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.472 15a6 6 0 01-8.943 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 2v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 10V9" })
	]
});
const ForwardRef = forwardRef(SvgEmojiPlus);
export default ForwardRef;
